export default {
  init() {
      $(document).on('gform_confirmation_loaded', function(event, formId){
        if(formId == 1) {
          $('html, body').animate({
            scrollTop: 0,
          }, 300)
        }
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-contact.js